import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const MULTILEAD_TINDER_AB_TEST_ID = "DDZZkz697ghj77zzlz67";

const MULTILEAD_TINDER_DEFAULT_VARIANT = "default" as const;
export const MULTILEAD_TINDER_VARIANT = "tinder" as const;

export const multileadTinderAbTests: IABTestConfiguration = {
    id: MULTILEAD_TINDER_AB_TEST_ID,
    name: OngoingABTests.MULTILEAD_TINDER,
    expires: new Date(2027, 11, 31),
    path: [rpAppPath.property.detail.base],
    variants: [MULTILEAD_TINDER_DEFAULT_VARIANT, MULTILEAD_TINDER_VARIANT],
    variantConfig: {
        [MULTILEAD_TINDER_DEFAULT_VARIANT]: 0.5,
        [MULTILEAD_TINDER_VARIANT]: 0.5
    },
    withSSR: true,
    matchOnAllPaths: true
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const MULTILEAD_TINDER_AB_TEST_ID = "DDZZkz697ghj77zzlz67";

const MULTILEAD_TINDER_DEFAULT_VARIANT = "default" as const;
export const MULTILEAD_TINDER_VARIANT = "tinder" as const;

export const multileadTinderAbTests: IABTestConfiguration = {
    id: MULTILEAD_TINDER_AB_TEST_ID,
    name: OngoingABTests.MULTILEAD_TINDER,
    expires: new Date(2027, 11, 31),
    path: [rpAppPath.property.detail.base],
    variants: [MULTILEAD_TINDER_DEFAULT_VARIANT, MULTILEAD_TINDER_VARIANT],
    variantConfig: {
        [MULTILEAD_TINDER_DEFAULT_VARIANT]: 0.5,
        [MULTILEAD_TINDER_VARIANT]: 0.5
    },
    withSSR: true,
    matchOnAllPaths: true
};
